import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import ProtectedRoute from "../utils/route-guard/ProtectedRoute";
import MainLayout from "../layout/MainLayout";
import AuthRoutes from "./AuthRoutes";
import PawnRoutes from "./PawnRoutes";
import AdminRoutes from "./SuperAdminRoutes";
import CarRoutes from "./CarRoutes";
import LandRoutes from "./LandRoutes";
import Loading from "../components/Loading";
import Home from "pages/Home";
import MarketPlace from "pages/Home/MarketPlace";
import PackagesContact from "pages/Home/PackagesContact";
import { CarBrandsProvider } from "contexts/CarBrandsContext";
import { CarStatusProvider } from "contexts/CarStatusContext";

const MainRoutes = () => {
  const { user, loading, packageTypes } = useAuth();

  if (loading) {
    return <Loading />;
  }

  const getDefaultRedirectPath = () => {
    if (user.role === "SuperAdminA" || user.role === "SuperAdminM") {
      return "/admin/super_admin";
    } else {
      if (packageTypes.includes(1)) {
        return "/pawn/dashboard_pawn";
      } else if (packageTypes.includes(2)) {
        return "/car/dashboard_cars";
      } else if (packageTypes.includes(3)) {
        return "/land/dashboard_land";
      }
      return "/error";
    }
  };

  return (
    <Routes>
      <Route path="/home" element={<Home />} />
      <Route path="/marketplace" element={<MarketPlace />} />
      <Route path="/contact" element={<PackagesContact />} />
      {!user ? (
        <Route path="/*" element={<AuthRoutes />} />
      ) : (
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            {packageTypes.length > 0 && (
              <>
                {packageTypes.includes(1) && (
                  <>
                    <Route
                      path="/pawn"
                      element={<Navigate to="/pawn/dashboard_pawn" replace />}
                    />
                    <Route
                      path="/admin"
                      element={<Navigate to="/admin/super_admin" replace />}
                    />
                    <Route
                      path="/admin/*"
                      element={<AdminRoutes role={user.role} />}
                    />
                    <Route
                      path="/pawn/*"
                      element={<PawnRoutes role={user.role} />}
                    />
                  </>
                )}
                {packageTypes.includes(2) && (
                  <>
                    <Route
                      path="/car"
                      element={<Navigate to="/car/dashboard_cars" replace />}
                    />
                    <Route
                      path="/car/*"
                      element={
                        <CarStatusProvider>
                          <CarBrandsProvider>
                            <CarRoutes role={user.role} />
                          </CarBrandsProvider>
                        </CarStatusProvider>
                      }
                    />
                  </>
                )}
                {packageTypes.includes(3) && (
                  <>
                    <Route
                      path="/land"
                      element={<Navigate to="/land/dashboard_land" replace />}
                    />
                    <Route
                      path="/land/*"
                      element={<LandRoutes role={user.role} />}
                    />
                  </>
                )}
              </>
            )}
            {["/", "/login"].map((path) => (
              <Route
                path={path}
                element={<Navigate to={getDefaultRedirectPath()} replace />}
              />
            ))}
            <Route path="*" element={<Navigate to="/error" replace />} />
          </Route>
        </Route>
      )}
    </Routes>
  );
};

export default MainRoutes;
